/*
    Copyright 2020 Lauren Gyldenlove.
    This file is part of Duelmaster.

    Duelmaster is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Duelmaster is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with Foobar.  If not, see <https://www.gnu.org/licenses/>.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSpring, animated } from 'react-spring';
import ankh from '../assets/ankh.svg';
import horus from '../assets/horus.svg';

const useStyles = makeStyles({
    coinWrapper: {
        width: "10em",
        height: "10em",
        margin: "1em auto"
    },
    coin: {
        position: "absolute",
        width: "10em",
        height: "10em",
        border: "4px outset #990",
        borderRadius: "50%",
        cursor: "pointer",
        willChange: "transform, opacity"
    },
    coinBack: {
        background: `#DD0 no-repeat url(${ankh}) center center / 10em 10em`
    },
    coinFront: {
        background: `#EE0 no-repeat url(${horus}) center center / 10em 10em`
    }
});

export interface CoinProps {
    flipSeconds: number;
    setFlipResult: Function;
}

export const Coin = (props: CoinProps) => {
    const classes = useStyles();

    const [flip, setFlip] = React.useState(false);
    const [isFlipping, setFlipping] = React.useState(false);
    const [isHeads, setHeads] = React.useState(true);
    const [flipCount, setFlipCount] = React.useState(0);
    const [finish, setFinish] = React.useState(false);

    const { transform, opacity } = useSpring({
        opacity: isHeads ? 1 : 0,
        transform: `perspective(600px) rotateX(${(180 * flipCount)}deg)`,
        config: { mass: 20, tension: 7000, friction: 100 }
    });

    const handleFlip = () => {
        //setFlip((f) => !f);
        const flipMilliseconds = props.flipSeconds;
        setFlipCount(0);
        setHeads(true);
        setFlipping(true);
        setTimeout(() => {
            setFlip(false);
            setFlipping(false);
            setFinish(true);
        }, flipMilliseconds);
    }

    React.useEffect(() => {
        let waitTime = Math.random() * 256 + 128;

        if(flip) {
            setHeads(!isHeads);
            setFlip(false);
            setFlipCount(flipCount + 1);
        } else if(isFlipping) {
            setTimeout(() => { 
                setFlip(true); 
            }, waitTime);
        } else if(finish) {
            setFinish(false);
            setTimeout(() => {
                props.setFlipResult(!isHeads);
            }, waitTime + 300)
        }
    }, [ flip, isHeads, isFlipping, flipCount, finish, props]);
        
    return (
        <div className={classes.coinWrapper} onClick={handleFlip}>
            <animated.div className={[ classes.coin, classes.coinBack ].join(" ")} style={{ opacity: opacity.interpolate(o => 1 - Number(o) || 0), transform: transform.interpolate(t => `${t} rotateZ(180deg)`)}}></animated.div>
            <animated.div className={[ classes.coin, classes.coinFront ].join(" ")} style={{ opacity: opacity, transform }}></animated.div>
        </div>
    );
}